export const TOKEN_EXPIRED_CODE = 5000;

export enum KeyboardCode {
  ENTER = "Enter",
  NUMPAD_ENTER = "NumpadEnter",
}

export enum EWallet {
  MOMO = 1,
  ZALO_PAY = 2,
}
